import { render, staticRenderFns } from "./TemperatureTargets.vue?vue&type=template&id=c45f812a&scoped=true&"
import script from "./TemperatureTargets.vue?vue&type=script&lang=ts&"
export * from "./TemperatureTargets.vue?vue&type=script&lang=ts&"
import style0 from "./TemperatureTargets.vue?vue&type=style&index=0&id=c45f812a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45f812a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDivider,VIcon,VSimpleTable,VTooltip})
